import React from 'react';
import styles from './circleWrapper.module.scss';
const CircleWrapper = (props: any) => {
    return <div className={styles['circleWrapper']}>{props.children}</div>;
};

export default CircleWrapper;
